export const isB3LauncherApp = () => {
  return !!new URLSearchParams(window.location.search).get('token');
};
